import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './style.module.scss';

import { AnimatePresence } from 'framer-motion';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Nav from './nav'

export default function Index() {
  const header = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const button = useRef(null);

  useEffect(() => {
    if (isActive) setIsActive(false);
  }, );

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.to(button.current, {
      scrollTrigger: {
        trigger: document.documentElement,
        start: 0,
        end: window.innerHeight,
        onLeave: () => {
          gsap.to(button.current, { scale: 1, duration: 0.25, ease: "power1.out" });
        },
        onEnterBack: () => {
          gsap.to(button.current, { scale: 0, duration: 0.25, ease: "power1.out" });
        },
      },
    });
  }, []);

  return (
    <>
      <div ref={header} className={`${styles.header}  text-white bg[#FFFFFF]`} >
        <div className={`${styles.logo} `} >
        <a href="/" className='flex pr-3'>
          <p className={styles.copyright}>©</p>
          <div className={styles.name}>
          
           <p className={styles.codeBy}>Code by</p>
            <p className={styles.dennis}>Shakil </p>
            <p className={styles.snellenberg}> Hossain</p>

         
          </div>
          </a>
        </div>
        <div className={` ${styles.nav}`}>
          <div className={styles.el}>
            <a href='/projects'>Work</a>
            <div className={styles.indicator}></div>
          </div>
          {/* <div className={styles.el}>
            <a href='/pricing'>Pricing</a>
            <div className={styles.indicator}></div>
          </div> */}
          <div className={styles.el}>
            <a href='/aboutpage'>About</a>
            <div className={styles.indicator}></div>
          </div>
          <div className={styles.el}>
            <a href='/contact'>Contact</a>
            <div className={styles.indicator}></div>
          </div>
        </div>
      </div>
      {/* <div ref={button} className={styles.headerButtonContainer}>
        <div onClick={() => setIsActive(!isActive)} className={`${styles.button}`}>
          <div className={`${styles.burger} ${isActive ? styles.burgerActive : ""}`}></div>
        </div>
      </div>
      <AnimatePresence mode="wait">
        {isActive && <Nav />}
      </AnimatePresence> */}
    </>
  );
}
